import styles from './styles.module.css';
import { CarAllocation } from '../../../types/carAllocation';

/** 表示する契約タイプの ID */
const visibleTypes = [1, 2, 3] as ReadonlyArray<unknown>;

type Props = {
  type: CarAllocation['collectionConstraintType'];
};

function CollectionConstraintTypeTag({ type }: Props) {
  if (!visibleTypes.includes(type.id)) return null;
  const firstLetter = type.name.substring(0, 1);
  return <span className={styles.constraintType}>{firstLetter}</span>;
}

export default CollectionConstraintTypeTag;
